import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { kycEndpoints } from "@/features/kyc/api/endpoints";
import type { CompanyProfileDto } from "@/features/kyc/api/dto";

/**
 * Profil entreprise rattaché à une identité
 * (`GET /CompanyProfiles/party/{partyId}`). 404 = pas de profil : pas de
 * retry (c'est un état métier normal, géré par l'UI en « créer »).
 */
export const useCompanyProfile = (partyId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.KYC_COMPANY_PROFILE(partyId),
    queryFn: () =>
      fetchDataGet<CompanyProfileDto>({
        url: kycEndpoints.companyProfiles.byParty(partyId),
      }),
    retry: (failureCount, error) =>
      !/404|401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(partyId),
  });
